<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ title | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="card-background modal-body">
    <h2 class="section-font" role="heading" aria-level="1">
      {{ "Types of Proof" | globalTranslate }}
    </h2>
    @if (staticTextDisplay) {
    <div>
      <p>
        {{ "TYPES_OF_PROOF_STATIC1" | globalTranslate }}
        <strong> {{ "TYPES_OF_PROOF_STATIC2" | globalTranslate }} </strong>
      </p>
      <p>
        {{ "TYPES_OF_PROOF_STATIC3" | globalTranslate }}
        <strong>{{ "TYPES_OF_PROOF_STATIC4" | globalTranslate }}</strong>
        {{ "TYPES_OF_PROOF_STATIC5" | globalTranslate }}
      </p>
    </div>
    }
    <hr />
    <div id="accordion">
      @for (item of data ; track item; let i = $index) {
      <div class="card card-background p-3 mb-1">
        <div [id]="'heading' + i">
          <h2 class="mb-0">
            <button
              class="accordion-button w-100 text-start d-flex justify-content-between align-items-center"
              type="button"
              (click)="item.show = !item.show"
              [attr.aria-controls]="'collapse' + i"
              [attr.aria-label]="
                (item.key | globalTranslate) +
                ', ' +
                (item.show
                  ? ('EXPANDED' | globalTranslate)
                  : ('COLLAPSED' | globalTranslate))
              "
            >
              <span class="item-key" aria-hidden="true">{{
                item.key | globalTranslate
              }}</span>
              <span class="item-key-symbol" aria-hidden="true">
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-angle-up': item.show,
                    'fa-angle-down': !item.show
                  }"
                  aria-hidden="true"
                ></i>
              </span>
            </button>
          </h2>
        </div>
        <div
          [id]="'collapse' + i"
          [ngClass]="{ show: item.show }"
          class="collapse"
          data-bs-parent="#accordion"
          role="region"
          [attr.aria-label]="(item.key | globalTranslate) + ' content'"
        >
          <div class="card-body">
            @if (item.key == 'TYPES_OF_PROOF_STATIC6') {
            <div>
              <div class="row">
                <div class="col-12 col-md-6 pb-2">
                  <ul class="item-val">
                    @for (itemVal of incomeProofColA; track itemVal) {
                    <li>{{ itemVal | globalTranslate }}</li>
                    }
                  </ul>
                </div>
                <div class="col-12 col-md-6 pb-2">
                  <ul class="item-val">
                    @for (itemVal of incomeProofColB; track itemVal) {
                    <li>{{ itemVal | globalTranslate }}</li>
                    }
                  </ul>
                </div>
              </div>
            </div>
            } @if (item.key == 'TYPES_OF_PROOF_STATIC7') {
            <div>
              <div class="criteriaTxt">
                {{ generalHeader | globalTranslate }}
              </div>
              <ul class="item-val">
                @for (itemVal of generalProof; track itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                }
              </ul>
              <div class="criteriaTxt">{{ otherProof | globalTranslate }}</div>
              <div class="criteriaTxt">{{ listAHeader | globalTranslate }}</div>
              <ul class="item-val">
                @for (itemVal of listAProof; track itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                }
              </ul>
              <div class="criteriaTxt">{{ listBHeader | globalTranslate }}</div>
              <ul class="item-val">
                @for (itemVal of listBProof; track itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                }
              </ul>
            </div>
            } @if (item.key === 'TYPES_OF_PROOF_STATIC17' || item.key ===
            'TYPES_OF_PROOF_STATIC26') {
            <div>
              @if (this.listARes) {
              <div>
                <ul class="item-val">
                  @for (itemVal of item.valueA; track itemVal) {
                  <li>{{ itemVal | globalTranslate }}</li>
                  }
                </ul>
              </div>
              }
              <!-- <div *ngIf="this.listBRes">
                <ul class="item-val">
                  <li *ngFor="let itemVal of item.valueB">{{itemVal | translate }}</li>
                </ul>
              </div> -->
            </div>
            } @if (item.key === 'TYPES_OF_PROOF_STATIC32') {
            <div>
              <ul class="item-val">
                @if (this.listAFin) { @for (itemVal of item.valueA; track
                itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                } } @if (this.listBFin) { @for (itemVal of item.valueB; track
                itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                } } @if (this.listCFin) { @for (itemVal of item.valueC; track
                itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                } }
              </ul>
            </div>
            } @if (item.key !== 'TYPES_OF_PROOF_STATIC6' && item.key !==
            'TYPES_OF_PROOF_STATIC7' && item.key !== 'TYPES_OF_PROOF_STATIC32'
            && item.key !== 'TYPES_OF_PROOF_STATIC17' && item.key !==
            'TYPES_OF_PROOF_STATIC26' ) {
            <div>
              <ul class="item-val">
                @for (itemVal of item.value; track itemVal) {
                <li>{{ itemVal | globalTranslate }}</li>
                }
              </ul>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>